import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './Components/header/header.component';
import { LandingComponent } from './Pages/landing/landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiHttpService } from './Service/api.http.service';
import { InterceptorService } from './Service/interceptor.service';
import { VerifyEmailComponent } from './Pages/verifyEmail/verifyEmail.component';
import { SharedModule } from './shared/shared.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AcceptComponent } from './Pages/accept/accept.component';
import { AboutusComponent } from './Pages/aboutus/aboutus.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { UnderConstructionComponent } from './User/Pages/under-construction/under-constructioncomponent';
import { PrivacyPolicyComponent } from './Pages/privacy-policy/privacy-policy.component';
import { ContactusComponent } from './Pages/contactus/contactus.component';
import { FooterComponent } from './Components/footer/footer.component';
import { TermsAndConditionsComponent } from './Pages/terms-and-conditions/terms-and-conditions.component';
import { CareersComponent } from './Pages/careers/careers.component';
import { SecureLinkAccessComponent } from './Pages/secure-link-access/secure-link-access.component';
import { SecureLinkAuthenticationComponent } from './Components/secure-link-authentication/secure-link-authentication.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { GdprComponent } from './Pages/gdpr/gdpr.component';
import { CcpaComponent } from './Pages/ccpa/ccpa.component';
import { LoginHeaderComponent } from './Pages/login-header/login-header.component';
import { TeamComponent } from './Pages/team/team.component';
import { PressComponent } from './Pages/press/press.component';
import { SecurityComponent } from './Pages/security/security.component';
import { TeamPopUpComponent } from './Pages/team/popup/team-popup.component';
import { ReferralsComponent } from './Pages/referrals/referrals.component';
import { AffiliatesComponent } from './Pages/affiliates/affiliates.component';
import { AboutUsPopUpComponent } from './Pages/aboutus/popup/aboutus-popup.component';
import { WelcomeComponent } from './Pages/executor-welcome/welcome.component';
import { DeclineComponent } from './Components/excutor-decline/decline.component';
import { ErrorHandlerService } from './Service/errorHandler.service';
import { UserIdleService } from './Service/user-idle.service';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { SecureFileShareComponent } from './Pages/secure-file-share/secure-file-share.component';
import { LoginLandingComponent } from './Pages/login-landing/login-landing.component';
import { ReferafriendComponent } from './Components/referafriend/referafriend.component';
import { NewslatterspopupComponent } from './Components/newslatterspopup/newslatterspopup.component';
import { ThankyouComponent } from './Components/newslatterspopup/thankyou/thankyou.component';
import { PcisbuscriptionComponent } from './PciSubScription/pcisbuscription/pcisbuscription.component';
import { AcceptFcInviteComponent } from './Pages/accept-fc-invite/accept-fc-invite.component';
import { IframeComponent } from './Pages/iframe/iframe.component';
import { ChatComponent } from './Pages/chat/chat.component';
import { UnsubscribeComponent } from './Pages/unsubscribe/unsubscribe.component';
import { AcceptInvitationComponent } from './Pages/accept-invitation/accept-invitation.component';
import { AcceptFcInviteFromUserComponent } from './Pages/accept-fc-invite-from-user/accept-fc-invite-from-user.component';
import { GuidevideosComponent } from './Components/guidevideos/guidevideos.component';
import { CircularCarouselComponent } from './Components/circular-carousel/circular-carousel.component';
import { HowItWorksComponent } from './Pages/how-it-works/how-it-works.component';
import { GetStartedBoxComponent } from './Components/get-started-box/get-started-box.component';
import { CostComponent } from './Pages/cost/cost.component';
import { FamiliesComponent } from './Pages/families/families.component';
import { ProfessionalsComponent } from './Pages/professionals/professionals.component';
import { CalendlyComponent } from './Pages/calendly/calendly.component';
import { PrivacyPolicyMblComponent } from './Pages/privacy-policy-mbl/privacy-policy-mbl.component';
import { TermsAndConditionsMblComponent } from './Pages/terms-and-conditions-mbl/terms-and-conditions-mbl.component';
import { NotificationsComponent } from './Pages/notifications/notifications.component';
import { IntroducingFamilyCentralComponent } from './Pages/introducing-family-central/introducing-family-central.component';
import { WelcomeVideoComponent } from './Pages/welcome/welcome.component';
import { WelcomeAdvisorsComponent } from './Pages/welcome-advisors/welcome-advisors.component';
import { LandingAbTestComponent } from './Pages/landing-ab-test/landing-ab-test.component';
import { LandingAbTestV2Component } from './Pages/landing-ab-test-v2/landing-ab-test-v2.component';
import { SignupTypeComponent } from './Pages/signup-type/signup-type.component';

@NgModule({
  declarations: [
    AboutusComponent,
    AppComponent,
    HeaderComponent,
    LandingComponent,
    VerifyEmailComponent,
    AcceptComponent,
    PricingComponent,
    UnderConstructionComponent,
    PrivacyPolicyComponent,
    ContactusComponent,
    FooterComponent,
    TermsAndConditionsComponent,
    CareersComponent,
    SecureLinkAccessComponent,
    SecureLinkAuthenticationComponent,
    FaqComponent,
    GdprComponent,
    CcpaComponent,
    LoginHeaderComponent,
    TeamComponent,
    PressComponent,
    SecurityComponent,
    TeamPopUpComponent,
    ReferralsComponent,
    AffiliatesComponent,
    AboutUsPopUpComponent,
    WelcomeComponent,
    DeclineComponent,
    ReferafriendComponent,
    LoginLandingComponent,
    SecureFileShareComponent,
    NewslatterspopupComponent,
    ThankyouComponent,
    PcisbuscriptionComponent,
    AcceptFcInviteComponent,
    IframeComponent,
    ChatComponent,
    UnsubscribeComponent,
    AcceptInvitationComponent,
    AcceptFcInviteFromUserComponent,
    GuidevideosComponent,
    CircularCarouselComponent,
    HowItWorksComponent,
    GetStartedBoxComponent,
    CostComponent,
    FamiliesComponent,
    ProfessionalsComponent,
    CalendlyComponent,
    PrivacyPolicyMblComponent,
    TermsAndConditionsMblComponent,
    NotificationsComponent,
    IntroducingFamilyCentralComponent,
    WelcomeVideoComponent,
    WelcomeAdvisorsComponent,
    LandingAbTestComponent,
    LandingAbTestV2Component,
    SignupTypeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgOtpInputModule,
    BrowserAnimationsModule,
    NgProgressModule.withConfig({
      color: '#6ca9e2',
      thick: true,
    }),
    NgProgressHttpModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    ApiHttpService,
    UserIdleService,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
